/* eslint-disable func-names,arrow-body-style,max-len */

import _ from 'lodash';
import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';

import SpottingGroup from '../models/SpottingGroupRecord';
import { providers } from './spottingGroupDrilldownReducers';
import {
  SPOTTING_GROUP_DRILLDOWN_FETCH_TERM,
  SPOTTING_GROUP_DRILLDOWN_SET_CURRENT_NAME,
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADED,
  SPOTTING_GROUP_DRILLDOWN_EDITING_SET_IS_EDITING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_EDITING_SAVE,
  SPOTTING_GROUP_DRILLDOWN_DELETE_CHECKED_TERMS,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADING,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADED,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOAD_ERROR,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_NAME,
  SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_RESET,
  SPOTTING_GROUP_DRILLDOWN_STOP_ADDING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_ADD_NEW_GROUP,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_GROUP_TERMS,
  SPOTTING_GROUP_DRILLDOWN_EDITING_DESTROY,
  SPOTTING_GROUP_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST,
} from './spottingGroupDrilldownConstants';

import {
  MODEL_SPOTTING_GROUP_ADD_RECORD,
  MODEL_SPOTTING_GROUP_REMOVE_RECORD,
} from '../models/SpottingGroup/spottingGroupConstants';

import {
  spottingGroupAddRecord,
  spottingGroupUpdateRecord,
  spottingGroupRemoveRecords,
  spottingGroupFetchRecord,
} from '../models/SpottingGroup';
import { SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR } from '../spottingGroup/spottingGroupConstants';

export default (bottle) => {
  bottle.factory('spottingGroupDrilldownHandlerFetchTerm', () => {
    return function* fetchTerm() {
      yield put({ type: SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADING });
      const [name, token] = yield select((state) => {
        return [
          _.get(state, 'spottingGroupDrilldown.name'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });


      if (!name) {
        return;
      }

      yield put(providers.setEditingTermName(name));

      if (!token) {
        yield put({ type: SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR, payload: 'no token' });
        return;
      }
      try {
        const payload = yield call(spottingGroupFetchRecord, name, token);
        yield put({
          type: MODEL_SPOTTING_GROUP_ADD_RECORD,
          payload,
        });
        yield put(providers.setTerms(payload.keywords));
        yield put({ type: SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADED });
      } catch (err) {
        yield put({ type: SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOAD_ERROR });
      }
    };
  });

  // note carryover from spottingGroupSaga prob needs reframe

  bottle.factory('spottingGroupDrilldownHandlerAddGroup', () => {
    return function* spottingGroupDrilldownHandlerAddGroup({ payload }) {
      const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (token) {
        yield call(spottingGroupAddRecord, payload, token);
        yield put({ type: SPOTTING_GROUP_DRILLDOWN_FETCH_TERM });
      }

      yield put({ type: SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_RESET });
      yield put({ type: SPOTTING_GROUP_DRILLDOWN_STOP_ADDING_GROUP });
    };
  });

  bottle.factory('spottingGroupDrilldownHandlerInitAddKeywords', () => {
    return function* spottingGroupDrilldownHandlerInitAddKeywords() {
      const [name, token] = yield select((state) => {
        return [
          _.get(state, 'spottingGroupDrilldown.name'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (token) {
        const group = yield call(spottingGroupFetchRecord, name, token);
        const keywords = _.get(group, 'keywords');
        if (keywords) {
          yield put(providers.setAddGroupTerms(keywords.join('\n')));
        }
      }
    };
  });

  bottle.factory('spottingGroupDrilldownHandlerTerminator', () => {
    return function* spottingGroupDrilldownHandlerTerminator() {
      const [name, termState, token] = yield select((state) => {
        return [
          _.get(state, 'spottingGroupDrilldown.name'),
          _.get(state, 'spottingGroupDrilldown.termState'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if ((!token) || (termState !== SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADED)) {
        return;
      }

      if (name) {
        yield call(spottingGroupRemoveRecords, [name], token);
        yield put({
          type: MODEL_SPOTTING_GROUP_REMOVE_RECORD,
          payload: name,
        });
      } else {
        console.log('attempt to delete without name');
      }
    };
  });

  bottle.factory('spottingGroupDrilldownHandlerGetGroupAndTerms', () => {
    return function* spottingGroupDrilldownHandlerGetGroupAndTerms() {
      const [name] = yield select((state) => {
        return [
          _.get(state, 'spottingGroupDrilldown.name'),
        ];
      });

      if (name) {
        yield put({ type: SPOTTING_GROUP_DRILLDOWN_FETCH_TERM });
      }
    };
  });

  bottle.factory('spottingGroupDrilldownHandlerSaving', () => {
    return function* () {
      const [groupName, newGroupName, keywords, token] = yield select((state) => {
        return [
          _.get(state, 'spottingGroupDrilldown.name'),
          _.get(state, 'spottingGroupDrilldown.currentTermEditedName'),
          _.get(state, 'spottingGroupDrilldown.termsEditing'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      const newRecord = new SpottingGroup({
        groupName: newGroupName || groupName,
        keywords,
      });

      yield put(providers.setAddingStateSaving());
      try {
        yield call(spottingGroupUpdateRecord, groupName, newRecord, token);
        yield put(providers.setCurrentNameID(newGroupName || groupName));
        yield put(providers.fetchTerm());
        yield put(providers.setAddingStateSaved());
      } catch (err) {
        yield put(providers.setSavingGroupError(_.get(err, 'error', _.get(err, 'message'))));
        yield put(providers.setAddingStateError());
      }
    };
  });

  bottle.factory('spottingGroupResetChecks', () => {
    return function* spottingGroupResetChecks() {
      yield put({
        type: SPOTTING_GROUP_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST,
        payload: [],
      });
    };
  });

  bottle.factory('spottingGroupDrilldownHandlerInitEditing', () => {
    return function* () {
      const [isEditing, name, terms] = yield select((state) => {
        return [
          _.get(state, 'spottingGroupDrilldown.isEditingGroup'),
          _.get(state, 'spottingGroupDrilldown.name'),
          _.get(state, 'spottingGroupDrilldown.terms'),
        ];
      });

      if (isEditing) {
        yield put({
          type: SPOTTING_GROUP_DRILLDOWN_SET_EDITING_NAME,
          payload: name,
        });
        yield put({
          type: SPOTTING_GROUP_DRILLDOWN_SET_EDITING_GROUP_TERMS,
          payload: _.cloneDeep(terms),
        });
      } else {
        yield put({ type: SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_RESET });
      }
    };
  });

  bottle.factory('spottingGroupDrilldownEditingStartSaga', ({ spottingGroupDrilldownHandlerInitEditing }) => {
    return function* spottingGroupDrilldownEditingStartSaga() {
      yield takeEvery(SPOTTING_GROUP_DRILLDOWN_EDITING_SET_IS_EDITING_GROUP, spottingGroupDrilldownHandlerInitEditing);
    };
  });

  bottle.factory('spottingGroupDrilldownAddGroupSaga', ({ spottingGroupDrilldownHandlerAddGroup }) => {
    return function* spottingGroupDrilldownAddGroupSaga() {
      yield takeEvery(SPOTTING_GROUP_DRILLDOWN_ADD_NEW_GROUP, spottingGroupDrilldownHandlerAddGroup);
    };
  });

  bottle.factory('spottingGroupDrilldownDeleteGroupSaga', ({ deleteVocabularies }) => {
    return function* spottingGroupDrilldownDeleteGroupSaga() {
      yield takeEvery(SPOTTING_GROUP_DRILLDOWN_DELETE_CHECKED_TERMS, deleteVocabularies);
    };
  });

  bottle.factory('spottingGroupDrilldownFetchSaga', ({ spottingGroupDrilldownHandlerFetchTerm }) => {
    return function* spottingGroupDrilldownFetchSaga() {
      yield takeEvery(SPOTTING_GROUP_DRILLDOWN_FETCH_TERM, spottingGroupDrilldownHandlerFetchTerm);
    };
  });

  bottle.factory('spottingGroupDrilldownLoadCurrentNameSaga', ({ spottingGroupDrilldownHandlerGetGroupAndTerms }) => {
    return function* spottingGroupDrilldownLoadCurrentNameSaga() {
      yield takeEvery(
        [
          SPOTTING_GROUP_DRILLDOWN_SET_CURRENT_NAME,
        ],
        spottingGroupDrilldownHandlerGetGroupAndTerms,
      );
    };
  });

  bottle.factory('spottingGroupDrilldownTerminatorSaga', ({ spottingGroupDrilldownHandlerTerminator }) => {
    return function* terminate() {
      yield takeLatest(
        SPOTTING_GROUP_DRILLDOWN_EDITING_DESTROY,
        spottingGroupDrilldownHandlerTerminator,
      );
    };
  });

  bottle.factory('spottingGroupDrilldownSaveSaga', ({ spottingGroupDrilldownHandlerSaving }) => {
    return function* spottingGroupDrilldownSaveSaga() {
      yield takeLatest(
        SPOTTING_GROUP_DRILLDOWN_EDITING_SAVE,
        spottingGroupDrilldownHandlerSaving,
      );
    };
  });
};
